// P:\0PJ\synforge\frontend\components\TokenLoader.tsx v3 2026.07.27 23:21 - personalDisplay now loads from server (account-based) instead of localStorage
"use client"

import { useEffect } from "react"
import { loadAndApplyTokens } from "@/styles/tokens"
import { loadPersonalDisplaySettings, applyPersonalDisplaySettings } from "@/styles/personalDisplay"

export default function TokenLoader() {
  useEffect(() => {
    async function init() {
      // 1) 어드민 기본값(DesignToken) 먼저.
      await loadAndApplyTokens()
      // 2) 이 계정에 저장된 개인 설정(서버 - workspace_settings.display)을 그 위에 덮어씌운다.
      //    비로그인 상태면 loadPersonalDisplaySettings 가 401 을 잡아 기본값을 반환한다.
      const personal = await loadPersonalDisplaySettings()
      applyPersonalDisplaySettings(personal)
    }
    init()
  }, [])

  return null
}